import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ConsoleLogger } from '@skylab-shared/core';

import { isString } from '@skylab-shared/utils';
import { fromEvent, Subject, takeUntil } from 'rxjs';

type ScrollSynchronizeAttributeType = `data-scroll-synchronize-${string}`;

@Directive({ selector: '[skl-synchronize-scroll]' })
export class SynchronizeScrollDirective {
    @Input('skl-synchronize-scroll') public data!: ScrollSynchronizeAttributeType | { group: ScrollSynchronizeAttributeType; target: string }

    private elements: Element[] = [];
    private destroy$ = new Subject<void>();

    private logger = new ConsoleLogger(this.constructor.name);

    public constructor(
        private readonly elRef: ElementRef<HTMLElement>,
        private readonly renderer: Renderer2
    ) { }

    public ngAfterViewInit(): void {
        if (!this.data) {
            this.logger.warn('synchronize scroll config object not set.');
            return;
        }

        const tag = `[${isString(this.data) ? this.data : this.data.group}]`;

        this.elements = Array.from(this.elRef.nativeElement.querySelectorAll(tag))
            .map(elem => isString(this.data) ? elem : elem.querySelector(this.data.target))
            .filter((elem): elem is Element => !!elem);


        this.addMouseEnterListeners();
        this.synchronize();
    }

    private mouseEnterListeners: (() => void)[]  = []
    private addMouseEnterListeners(): void {
        this.elements.forEach(elem => {
            this.mouseEnterListeners.push(this.renderer.listen(elem, 'mouseenter', () => {
                this.setCurrentScrolledElement(elem);
            }))
        })
    }

    private synchronize(): void {
        this.elements.forEach(element => {
            fromEvent(element, 'scroll')
                .pipe(takeUntil(this.destroy$))
                .subscribe(_ => {
                    this.elements.forEach(elem => {
                        if (elem === this.currentScrolledElement) return;
                        elem.scrollLeft = element.scrollLeft;
                    })
                })
        })
    }

    private currentScrolledElement: Element | null = null;
    private setCurrentScrolledElement(element: Element): void {
        this.currentScrolledElement = element;
    }

    public ngOnDestroy(): void {
        this.destroy$.unsubscribe();
        this.mouseEnterListeners.forEach(dispose => dispose());
    }
}
